import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import { Button, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#0000008a',
    marginLeft: '0px',
  },
  button: {
    marginRight: theme.spacing(2),
  },
}));

const UserForm = ({ formik, error }) => {
  const classes = useStyles();
  const history = useHistory();
  const [submitErrors, setSubmitErrors] = useState({
    folderName: '',
  });

  useEffect(() => {
    if (error) setSubmitErrors(error.graphQLErrors[0].extensions.errors);
  }, [error]);

  return (
    <>
      <form onSubmit={formik.handleSubmit} noValidate>
        <Grid container direction="column" spacing={6}>
          <Grid container item xs={12} direction="column" spacing={2}>
            <Grid container item xs={12}>
              <Grid item xs={12} md={4}>
                <TextField
                  required
                  name="netId"
                  id="netId"
                  label="NetID"
                  type="text"
                  {...formik.getFieldProps('netId')}
                  error={
                    !!(
                      formik.touched.netId &&
                      (formik.errors.netId || submitErrors.netId)
                    )
                  }
                  helperText={
                    formik.touched.netId &&
                    (formik.errors.netId || submitErrors.netId)
                      ? submitErrors.netId || formik.errors.netId
                      : 'NetID of admin'
                  }
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={4}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="role-label">Role</InputLabel>
                  <Select
                    labelId="role-label"
                    id="role"
                    {...formik.getFieldProps('role')}
                  >
                    <MenuItem value="Admin">Admin</MenuItem>
                  </Select>
                  <FormHelperText>Role (admin only)</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={4}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Switch
                        id="active"
                        name="active"
                        color="primary"
                        checked={formik.values.active}
                        {...formik.getFieldProps('active')}
                      />
                    }
                    label="Active"
                    className={classes.label}
                    labelPlacement="start"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={formik.handleSubmit}
            >
              submit
            </Button>
            <Button
              variant="outlined"
              color="default"
              onClick={() => {
                history.goBack();
              }}
            >
              cancel
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

UserForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formik: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.any.isRequired,
};

export default UserForm;
